<div class="inscript-section" *ngIf="infoFormation">
  <div class="align-center margin-top-1">
    <h3><b>Inscriptions</b></h3>
  </div>
  <div class="primary-background colored-text small-padding">
    <b>Formations inter-entreprises</b>
  </div>
  <div class="micro-padding " *ngIf="infoFormation">
    <div class="float-right">{{ !!infoFormation.inscriptions ? infoFormation.inscriptions.groupe : '' }}</div>
    <div>Groupe</div>
  </div>
  <div class="micro-padding" *ngIf="infoFormation">
    <div class="float-right">{{ !!infoFormation.inscriptions ? infoFormation.inscriptions.duree : '' }}</div>
    <div>Durée</div>
  </div>
  <div *ngIf="filteredSessionList.length !== 0">
    <div class="micro-padding">Votre lieu de formation</div>
    <kendo-dropdownlist
      [data]="listeSites"
      [textField]="'libelle'"
      [valueField]="'id'"
      [(value)]="selectedSiteId"
      [valuePrimitive]="true"
      class="micro-padding full-size"
    ></kendo-dropdownlist>
  </div>
  <div *ngIf="filteredSessionList.length !== 0">
    <div class="inscript-card" *ngFor="let session of filteredSessionList">
      <div>
        <b>Dates :</b> {{ session.debut | kendoDate: 'dd/MM/yyyy' }} - {{ session.fin | kendoDate: 'dd/MM/yyyy' }}
      </div>
      <div *ngIf="session.places > 0"><b>Places disponibles :</b> {{ session.places }}</div>
      <div *ngIf="session.places <= 0" class="alert-color"><b>Complet</b></div>
      <div>
        <div><b>Contacter le responsable formation :</b></div>
        <div>
          {{ session.responsable.nom }}
          {{ session.responsable.prenom }} <br />
          {{ session.responsable.mail }} <br />
          {{ session.responsable.tel }}
        </div>
      </div>
      <div *ngIf="session.places > 0 && cartLink" class="small-margin align-center">
        <ags-add-to-cart [formation]="infoFormation" [session]="session" [modalite]="modalite"></ags-add-to-cart>
        <!--    bouton "ajouter au pannier" doit provenir du module "cart"  -->
      </div>
    </div>
    <div class="align-center margin-bot-1">
      <button
        *ngIf="sessionPage > 0"
        kendoButton
        [icon]="'arrow-chevron-left'"
        look="flat"
        (click)="sessionPage = sessionPage - 1"
      ></button>
      page {{ sessionPage + 1 }} / {{ nbSessionPage + 1 }}
      <button
        *ngIf="sessionPage < nbSessionPage"
        kendoButton
        [icon]="'arrow-chevron-right'"
        look="flat"
        (click)="sessionPage = sessionPage + 1"
      ></button>
    </div>
  </div>
  <div>
    <div *ngIf="filteredSessionList.length === 0">
      <p class="alert-color k-text-center">
        Aucune session prévue pour cette formation
      </p>
    </div>
  </div>
  <div class="primary-background colored-text small-padding"><b>Formations intra</b></div>
  <div class="micro-padding"><b>Tarif :</b> Nous contacter</div>
  <div class="micro-padding" *ngIf="infoFormation">
    <b>Durée conseillée :</b> {{ !!infoFormation.inscriptions ? infoFormation.inscriptions.duree : '' }}
  </div>
  <div class="micro-padding" *ngIf="infoFormation">
    <b>Groupe :</b> {{ !!infoFormation.inscriptions ? infoFormation.inscriptions.groupe : '' }}
  </div>
  <!--<div class="align-center">-->
  <!--<div>0013467982</div>-->
  <!--</div>-->
</div>
